import { render, staticRenderFns } from "./WSeminar.vue?vue&type=template&id=89e0ce6c&"
import script from "./WSeminar.vue?vue&type=script&lang=js&"
export * from "./WSeminar.vue?vue&type=script&lang=js&"
import style0 from "./WSeminar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports